module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('div', {
    staticClass: "left-wrapper"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.imgUrl ? _vm.imgUrl : _vm.noPeriodPic,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "period-name"
  }, [_vm._v(_vm._s(_vm.periodName))])]), _vm._v(" "), _c('div', {
    staticClass: "v-divide"
  }), _vm._v(" "), _c('div', {
    staticClass: "right-wrapper"
  }, [_c('div', {
    staticClass: "headers"
  }, [_c('div', {
    class: _vm.statusClass
  }, [_vm._v(_vm._s(_vm.getStatusText(_vm.status)) + _vm._s('  ' + (_vm.hallName ? _vm.hallName : '')))])]), _vm._v(" "), (_vm.dishes && _vm.dishes.length >= 0) ? _c('div', {
    staticClass: "dishes"
  }, [_vm._v("\n      " + _vm._s(_vm.dishes.join('、')) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72237c2a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/period.vue
// module id = 866
// module chunks = 34